import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { IMAGE_DOMAIN } from 'config'
import { Link } from 'react-router-dom'
import TileList from 'components/TileList'
import BrandNav from 'components/BrandNav'
import './styles.css'

const recipes = [
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/01.jpg`,
    name: '雞茸蒸豆腐',
    link: '/asko/recipes/01'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/02.jpg`,
    name: '奶香椰汁南瓜',
    link: '/asko/recipes/02'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/03.jpg`,
    name: '番茄荳蔻牛肉湯',
    link: '/asko/recipes/03'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/04.jpg`,
    name: '牛蒡香菇飯',
    link: '/asko/recipes/04'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/05.jpg`,
    name: '粉蒸肉地瓜',
    link: '/asko/recipes/05'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/06.jpg`,
    name: '養生蒸魚',
    link: '/asko/recipes/06'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/07.jpg`,
    name: '原味蘿蔔糕',
    link: '/asko/recipes/07'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/08.jpg`,
    name: '蔥香烤魚',
    link: '/asko/recipes/08'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/09.jpg`,
    name: '香滷豬腳',
    link: '/asko/recipes/09'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/10.jpg`,
    name: '培根鳳梨捲',
    link: '/asko/recipes/10'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/11.jpg`,
    name: '香草烤雞',
    link: '/asko/recipes/11'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/12.jpg`,
    name: '橙汁烤雞腿',
    link: '/asko/recipes/12'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/13.jpg`,
    name: '焗香烤飯',
    link: '/asko/recipes/13'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/14.jpg`,
    name: '鮮蔬烘蛋',
    link: '/asko/recipes/14'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/15.jpg`,
    name: '蒜香骰子牛',
    link: '/asko/recipes/15'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/16.jpg`,
    name: '南瓜酥皮濃湯',
    link: '/asko/recipes/16'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/17.jpg`,
    name: '優格',
    link: '/asko/recipes/17'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/18.jpg`,
    name: '免揉歐式麵包',
    link: '/asko/recipes/18'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/19.jpg`,
    name: '重乳酪蛋糕',
    link: '/asko/recipes/19'
  },
  {
    imageSrc: `${IMAGE_DOMAIN}asko/recipe/cover/20.jpg`,
    name: '香草蛋糕',
    link: '/asko/recipes/20'
  },
]

class Recipe extends Component {
  componentDidMount() {
    document.title = '食譜'
    window.scrollTo(0, 0)
  }

  render = () => {
    const brandId = this.props.match.params.brand

    return (
      <div style={{ marginTop: '65px' }}>
        <BrandNav brand={brandId} />
        <section className="masonry-contained" style={{ marginTop: '30px' }}>
          <div className="container">
            <div className="row">
              <TileList items={recipes.map(recipe => this.renderRecipe(recipe))} />
            </div>
          </div>
        </section>
      </div>
    )
  }

  renderRecipe = (item) => (
    <Link key={item.name} to={item.link}>
      <div className="card card-7">
        <div className="card__image">
          <img alt={item.name} src={item.imageSrc} />
        </div>
        <div className="card__body boxed" style={{ background: "#EEEEEE" }}>
          <div className="card__title">
            <h5>{item.name}</h5>
          </div>
        </div>
      </div>
    </Link>
  )
}

export default withRouter(Recipe)



// WEBPACK FOOTER //
// ./src/containers/Recipe/index.js